import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import AddLicenseRightsHeader from "./AddLicenseRightsHeader";
import LicenseRightsRows from "./LicenseRightsRows";

interface DataArrItemType {
  Column_name: string;
  name: string;
}
interface AllTickType {
  Page_Access?: boolean;
}
let DataArr: DataArrItemType[] = [
  {
    Column_name: "Access",
    name: "Page_Access",
  },
];

const AddLicenseRights = ({ searchPage, data, handleRights }) => {
  const [allTick, setAllTick] = useState<AllTickType>({});
  const [totalPrice, setTotalPrice] = useState(0);
  const [selectAll, setSelectAll] = useState(false);
  const [selectedIds, setSelectedIds] = useState<any[]>([]);
  const [PagesData, setPagesData] = useState(data);
  const dispatch = useDispatch();

  useEffect(() => {
    if (searchPage && data?.length) {
      let filteredData = data?.filter((el) => {
        let PageName = (el?.Page_Name).toLowerCase();
        return PageName?.includes(searchPage.toLowerCase());
      });
      setPagesData(filteredData);
    } else {
      setPagesData(data);
    }
  }, [searchPage, data]);

  const handleCheckboxChange = (id: string, price: number, isChecked: boolean, isSelectAllChange: boolean) => {
    setTotalPrice((prevTotal) => (isChecked ? prevTotal + price : prevTotal - price));
    const selectedItem = data.find((item) => item._id === id);
    if (!selectedItem) {
      console.error("Item not found");
      return;
    }
    // if (isSelectAllChange) {
    //   setAllTick((prevAllTick) => ({
    //     ...prevAllTick,
    //     Page_Access: isChecked,
    //   }));
    // }
    const isCurrentlyChecked = selectedItem.Page_Access;
    setSelectedIds((prev) => {
      console.log(selectedItem)
      const existingItemIndex = prev.findIndex((item) => item.id === id);
      if (existingItemIndex > -1) {
        // item exists in selectedIds
        const updatedSelectedIds = [...prev];
        updatedSelectedIds[existingItemIndex].Page_Access = !isCurrentlyChecked; // toggle
        return updatedSelectedIds;
      } else {
        // item doesn't exist in selectedIds
        let ReturnValue = [
          ...prev,
          {
            id: selectedItem._id,
            Licensee_Master_ID: selectedItem.Licensee_Master_ID,
            Licensee_No: selectedItem.Licensee_No,
            Page_Access: !isCurrentlyChecked, // toggle
            Page_Master_ID: selectedItem.Page_Master_ID,
          },
        ];
        return ReturnValue;
      }
    });
  };

  const handleAllTickAdd = ({ name, checked }) => {
    if (name === "Page_Access") {
      setSelectAll(checked);
      // Update every item's Page_Access to the value of 'checked'
      const allIds = data.map((item) => ({
        id: item?.id,
        Licensee_Master_ID: item?.Licensee_Master_ID,
        Licensee_No: item?.Licensee_No,
        Page_Access: checked, // set all Page_Access to the checkbox's value
        Page_Master_ID: item?.Page_Master_ID,
      }));
      const newTotalPrice = allIds.reduce(
        (sum, item) => (item.Page_Access ? sum + (data.find((d) => d.id === item.id)?.Price || 0) : sum),
        0
      );

      setTotalPrice(newTotalPrice);
      setSelectedIds(allIds);
    }
  };

  useEffect(() => {
    dispatch({ type: "AddLicenseeData", payload: { data: selectedIds } });
  }, [selectedIds]);

  return (
    <>
      <table className="table">
        <thead>
          <tr className="table-row">
            <th className="table-header">{`Page Name (${PagesData.length}) `}</th>
            <th className="table-header">Module Name</th>
            <th className="table-header">Price</th>
            {DataArr &&
              DataArr.length > 0 &&
              DataArr.map((el) => (
                <AddLicenseRightsHeader
                  Column_name={el.Column_name}
                  name={el.name}
                  disabled={allTick.Page_Access === undefined || allTick.Page_Access === false}
                  func={(e: any) => handleAllTickAdd(e.target)}
                />
              ))}
          </tr>
        </thead>
        <tbody>
          {PagesData &&
            PagesData.length > 0 &&
            PagesData.map((el, i) => (
              <LicenseRightsRows
                onChange={handleCheckboxChange}
                key={i}
                data={el}
                handleEdit={""}
                allTick={allTick}
                selectAll={selectAll}
              />
            ))}

          <td colSpan={4} className="PagePrices">
            Total Price: {totalPrice}
          </td>
        </tbody>
      </table>
    </>
  );
};

export default AddLicenseRights;
